import {Component} from '@angular/core';
import {environment} from '@env/environment';

@Component({
    selector: 'ngc-account-expired',
    templateUrl: './account-expired.component.html',
    styleUrls: ['./account-expired.component.scss']
})
export class AccountExpiredComponent {

    protected readonly environment = environment;

}
